export default __webpack_public_path__ + "static/media/streaks 1.636ae4ca.svg";